/**
 * Chairside (assistant role test 2026-10-20): the turnover and room setup
 * card (`/turnover`), the setup table by procedure, "Complete for Dr. X",
 * the premed check at seating, the checkout check and the next-visit
 * request (the last three are used by the schedule, chart and notes).
 */
import { defineManifest } from '@velora/contracts';
import { CHAIRSIDE_ENTITY, CHAIRSIDE_PERMISSIONS as P } from '@velora/contracts/chairside';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'chairside',
    title: 'Chairside',
    version: '0.1.0',
    owner: 'WP2-CHAIRSIDE',
    entitlementKey: null,
    permissions: [...new Set(Object.values(P))],
    routes: [
      {
        id: 'turnover',
        path: '/turnover',
        title: 'Turnover',
        officeScope: 'location',
        permission: P.view,
        readsPhi: true,
      },
    ],
    nav: [
      {
        label: 'Turnover',
        group: 'clinical',
        routeId: 'turnover',
        icon: 'clipboard-list',
        order: 15,
        permission: P.view,
      },
    ],
    commands: [
      {
        id: 'chairside.turnover',
        title: 'Turnover and room setup',
        keywords: ['turnover', 'room', 'setup', 'tray', 'next patient', 'my op', 'my doctor'],
        routeId: 'turnover',
        permission: P.view,
      },
    ],
    sseEntityKeys: [CHAIRSIDE_ENTITY],
    phiReadPoints: ['chairside.turnover', 'chairside.visit', 'chairside.completions'],
  }),
  pages: {
    turnover: () => import('./TurnoverPage.js'),
  },
});
